let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cbxp8")).then(() => parcelRequire('dzT9C'));